export default "__VITE_ASSET__b987feed__"